import { on } from "events";
import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import ConfirmDialog from "../../ui/ConfirmDialog";
import donViTien from "./donViTien";
import DonViTien from "./donViTien";
import store from "../store";
import { ContactsApi } from "../restapi/contactsApi";
import worker from "../setupWorker";
import { reloadWindows } from "../../../electron/utils";

type OwnProps = {
    contactId: number,
    isOpen: boolean,
    onClose: () => void,
    onSaveData?: (data: any[]) => void,
}

const DonViTienDialog: FC<OwnProps> = ({
    contactId,
    onClose,
    isOpen,
    onSaveData,
}) => {
    const [state, setState] = useState({
        donViTien: [],
        reload: new Date(),
    })
    useEffect(() => {
        ContactsApi.getDonViTien({ contactId }).then((res: any) => {
            //if (isOpen) {
                if (res.errorCode == 0) {
                    setState((prev: any) => ({ ...prev, donViTien: res.data }))

                }
            //}
        }
        )
        // Fetch data from API or perform any other side effects here
    }, [state.reload])
    function saveDonViTien() {
        const data = store.getState().contact!.donViTien!
        ContactsApi.saveDonViTien(data).then((res: any) => {
            if (res.responseText != "") {
                worker.postMessage({
                    type: 'showsnackbar',
                    data:
                        res.responseText,
                })
            }
            setState((prev: any) => ({ ...prev, reload: new Date() }))
            if (res.errorCode == 0) {
                onClose()
            }
        })
    }
    return (
        <ConfirmDialog isOpen={isOpen}
            confirmHandler={() => { saveDonViTien() }}
            onClose={onClose}
            confirmLabel="Lưu"
            title="Quy đổi đơn vị tiền tệ">
            <DonViTien donViTien={state.donViTien} allowAddRemove={false} />
        </ConfirmDialog>
    )
}
export default memo(DonViTienDialog);